import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const voidTransferOrderRequest: RequestExample = {
    title: {
        verb: 'POST',
        endpointUrl: '/api/transfer-orders/:id/void',
    },
    curl:
        `curl --location \\
--request POST '<YOUR SERVER>/api/transfer-orders/:id/void' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const voidTransferOrderResponse: Json = {
    title: 'RESPONSE',
    json: {
        'id': 22,
        'number': '24',
        'status': 'Void',
        'type': 'Ship',
        'fromLocationGroup': {
            'id': 1,
            'name': 'Main'
        },
        'toLocationGroup': {
            'id': 2,
            'name': 'NY'
        },
        'carrier': {
            'id': 4,
            'name': 'Fedex',
            'service': {
                'id': 8,
                'name': 'Ground'
            }
        },
        'shipFromAddress': {
            'name': 'Main Warehouse',
            'street': '100 Main St',
            'city': 'Salt Lake City',
            'state': 'UT',
            'postalCode': '84101',
            'country': 'UNITED STATES'
        },
        'shipToAddress': {
            'name': 'East Warehouse',
            'street': '200 East Blvd',
            'city': 'Denver',
            'state': 'CO',
            'postalCode': '80201',
            'country': 'UNITED STATES'
        },
        'note': 'Urgent transfer for Q2 rebalancing',
        'ownerIsFrom': true,
        'revisionNumber': 2,
        'lastModified': {
            'username': 'admin',
            'dateLastModified': '2026-06-25T16:27:57.000+00:00'
        },
        'dateCreated': '2026-05-15T21:17:24.000+00:00',
        'dateIssued': '2026-06-05T18:34:29.000+00:00',
        'dateScheduled': '2025-12-29T01:44:45.000+00:00',
        'toItems': [
            {
                'id': 90,
                'part': {
                    'id': 28,
                    'name': 'B201',
                    'description': 'Premium Brake Cables'
                },
                'type': {
                    'id': 10,
                    'name': 'Send'
                },
                'status': 'Void',
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'lineNumber': 1,
                'note': 'Handle with care',
                'quantity': '10',
                'quantityFulfilled': '3',
                'quantityPicked': '3',
                'unitCost': '25.50',
                'dateScheduled': '2026-05-15T21:17:24.000+00:00'
            }
        ],
        'customFields': [
            {
                'id': 22,
                'name': 'Department',
                'value': 'Logistics',
                'type': 'Text'
            }
        ]
    },
};

const data: RequestDefinitionData = {
    id: 'void-transfer-order',
    title: 'Void a transfer order',
    description: 'Transitions an Issued transfer order to Void status. ' +
        'Voiding voids all associated pick items, sets all line item statuses to Void, ' +
        'sets the transfer order status to Void, and deletes any receipts. ' +
        'Only transfer orders in Issued status can be voided. ' +
        'Returns 404 if the transfer order is not found.',
    endpoint: {
        verb: 'POST',
        path: '/transfer-orders/:id/void',
        tooltip: 'Void a transfer order',
    },
    attributes: [],
    requestObject: voidTransferOrderRequest,
    responseObject: voidTransferOrderResponse,
};

export default data;
